var React = require('react');

function IconYoutube (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M24.255 1.061C22.778-.039 15.716 0 13.114 0 10.402 0 3.754-.023 2.23.927.806 1.816.062 5.891 0 9.674c.062 3.782.8 7.593 2.23 8.484 1.524.95 8.169.92 10.884.92 2.6 0 9.666.049 11.141-1.052 1.3-.974 1.917-4.636 1.928-8.352-.005-3.713-.625-7.642-1.928-8.613zM10.599 14.604V4.479l7.479 5.062z"}));
}

IconYoutube.defaultProps = {"viewBox":"0 0 26.183 19.083"};

module.exports = IconYoutube;

IconYoutube.default = IconYoutube;
